export enum ErrorType {
  UNEXPECTED = 'unexpected',
  NOT_FOUND = 'notFound'
}
